/**
 * Minimální className helper. Bez závislostí.
 * cx('a', cond && 'b', undefined, 'c') => 'a b c'
 */
export function cx(...parts: Array<string | false | null | undefined>): string {
  let out = '';
  for (const p of parts) {
    if (!p) continue;
    if (out) out += ' ';
    out += p;
  }
  return out;
}
